import React, { createContext, useState, useEffect, useContext } from "react";
import api from "../api"; // your Axios instance

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const [pages, setPages] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        setLoading(true);
        const res = await api.get("/api/footer"); // call your footer API
        setPages(res.data || {});
      } catch (err) {
        console.error("Error fetching footer pages:", err);
        setPages({});
      } finally {
        setLoading(false);
      }
    };

    fetchFooterData();
  }, []);

  return (
    <PageContext.Provider value={{ pages, loading }}>
      {children}
    </PageContext.Provider>
  );
};

// Custom hook to use pages
export const usePages = () => {
  return useContext(PageContext);
};
